import { ReactNode } from "react";

import Footer from "./Footer";
import Header from "./Header";
import { useSidebarContext } from "@/contexts/SidebarContext";
import { cn } from "@/lib/utils";
import Link from "next/link";
import { useRouter } from "next/router";
import { useModal } from "@/contexts/ModalContext";
import { useGlobalLoading } from "@/contexts/Loading";
import Loader from "@/components/Loader";
import { classNames } from "@/helpers";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import SideBar from "./Sidebar";
import { useAppDetails } from "@/contexts/AppDetailsContext";
import Meta from "./Meta";
import { useRecoilValue } from "recoil";
import { timezoneAtom } from "@/Atoms/settings/TimezoneAtom";

interface LayoutProps {
  meta?: ReactNode;
  header?: ReactNode;
  footer?: ReactNode;
  children?: ReactNode;
  className?: string;
  trainingComponent?: ReactNode;
  IdeasStream?: ReactNode;
  hideRiskWarning?: boolean;
  hideSpaceWhenNoRiskWarning?: boolean;
  hideIdeastream?: boolean;
  hideHeader?: boolean;
  hideSidebar?: boolean;
  onScrollBg?: boolean;
  showDisabled?: boolean;
}

export default function Layout(props: LayoutProps) {
  const modal = useModal();
  const router = useRouter();
  const globalLoading = useGlobalLoading();
  const { showSidebar } = useSidebarContext();
  const { details } = useAppDetails();
  const timezone = useRecoilValue(timezoneAtom);
  return (
    <>
      {globalLoading.loading ? (
        <div className="!h-[100vh] !w-full flex justify-center items-center">
          <Loader />
        </div>
      ) : (
        <div
          className={classNames(
            "antialiased w-full h-full flex flex-col loading-container ",
            globalLoading.loading ? "h-[100vh] overflow-hidden " : "",
            props.className,
          )}
        >
          <div className="relative h-0 -z-10">
            <span
              className="absolute invisible"
              style={{ fontFamily: `"Shoika"` }}
            >
              &nbsp;
            </span>
          </div>
          <div
            className={
              "transitions-all flex flex-col min-h-screen w-full bg-card dark:bg-card main-load " +
              (modal.open ? "blur-sm" : "")
            }
          >
            {details.isWhiteLabled ? (
              <Meta
                title={details?.appName ?? ""}
                description={details?.brokerName}
              />
            ) : (
              props.meta
            )}
            {!props.hideSidebar && (
              <SideBar showDisabled={props?.showDisabled} />
            )}
            <div
              className={cn(
                "flex flex-col flex-grow w-full min-h-screen transition-all duration-150 ease-in-out",
                !props.hideSidebar && (showSidebar ? "lg:pl-[222px]" : "lg:pl-[70px]")
              )}
            >
              {typeof props.header !== "undefined" ? (
                props.header
              ) : props?.hideHeader ? (
                <Header
                  hideHeader={props?.hideHeader}
                  onScrollBg={props?.onScrollBg}
                  showDisabled={props?.showDisabled}
                  hideSidebar={props?.hideSidebar}
                />
              ) : (
                <Header showDisabled={props?.showDisabled} hideSidebar={props?.hideSidebar} />
              )}

              <div
                key={timezone}
                className={cn(
                  "w-full flex-grow",
                  router.pathname?.includes("logout") ? "!w-full" : "",
                  props.hideSidebar ? "!w-full !h-full" : "",
                )}
              >
                {props.children}
              </div>
              {typeof props.trainingComponent !== "undefined"
                ? props.trainingComponent
                : ""}
              {typeof props.footer !== "undefined" ? props.footer : <Footer />}
            </div>
          </div>
          <div id="intercom-custom"></div>
          <Dialog open={modal.open}>
            <DialogContent>{modal.body}</DialogContent>
          </Dialog>
        </div>
      )}
    </>
  );
}
